import {useEffect} from 'react';

interface GestureEvent extends Event {
    scale?: number;
    clientX?: number;
    clientY?: number;
    screenX?: number;
    screenY?: number;
}

// Adapted from https://github.com/openstreetmap/iD/blob/d01bb7870772f8f8a73ccf660708ae094502da2a/modules/renderer/map.js#L345

export function useSafariPinchZoom(map: MapboxMap | undefined) {
    useEffect(() => {
        if (!map) return;

        const canvas = map.getCanvas();

        if (!canvas || !canvas.addEventListener) return;

        let scale = 1;
        let lastScale = 0;

        function onGestureStart(event: Event) {
            event.preventDefault();
            lastScale = 0;
        }

        function onGestureChange(event: GestureEvent) {
            event.preventDefault();
            if (!event.scale) return;

            lastScale = scale;
            scale = event.scale;

            map?.getCanvasContainer().dispatchEvent(
                new WheelEvent('wheel', {
                    deltaMode: 0,
                    deltaY: scale > lastScale ? -4 : 4,
                    clientX: event.clientX,
                    clientY: event.clientY,
                    screenX: event.screenX,
                    screenY: event.screenY,
                })
            );
        }

        canvas.addEventListener('gesturestart', onGestureStart);
        canvas.addEventListener('gesturechange', onGestureChange);

        return () => {
            canvas.removeEventListener('gesturestart', onGestureStart);
            canvas.removeEventListener('gesturechange', onGestureChange);
        };
    }, [map]);
}
